import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';
export function getCurrentMedicationSettings() {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).get("api/v1/medication-settings");
}
export function getCurrentStateTerritoryTermSettings() {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).get("api/v1/medication-settings/state-territory-term-settings");
}
